import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/apiClient'
import type { SubscriptionResponse } from '@/types/miniApp'

export function useSubscription(enabled: boolean) {
  return useQuery<SubscriptionResponse>({
    queryKey: ['mini-app', 'subscription'],
    queryFn: async () => (await apiClient.get('/api/mini-app/subscription')).data,
    enabled,
  })
}
